import React, { ComponentProps } from 'react';
import { Route, withRouter, RouteComponentProps } from 'react-router-dom';

import { fomatParentPath } from '../../utils';
import { MobPersonalCenter } from '../../lib';

function RouteMobPersonalCenter(props: RouteComponentProps & ComponentProps<any>) {
  const parentPath: string = fomatParentPath(props);
  return (
    <Route weId={`${props.weId || ''}_x7eiky`} exact path={`${parentPath}/mobile/uk/me`}>
      {
        <MobPersonalCenter weId={`${props.weId || ''}_jx0jn0`} />
      }
    </Route>
  )
}

export default withRouter(RouteMobPersonalCenter);